import classNames from "classnames"
import * as React from "react"

export type TabsProps = {
  children: React.ReactNode
  className?: string
}

export const Tabs = ({ children, className }: TabsProps) => (
  <nav className={classNames("tabs", className)} role="menu" aria-orientation="horizontal">
    {children}
  </nav>
)
